import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import MeteringGroupEditor from "./MeteringGroupEditor";
import MeteringPointEditor from "./MeteringPointEditor";
import MeteringTariffEditor from "./MeteringTariffEditor";

export default function MeteringSettings(props) {
    const { facility } = props;

    const { t } = useTranslation();

    const [activeTab, setActiveTab] = React.useState("points");

    return (
        <Stack height="100%">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={(event, newValue) => setActiveTab(newValue)}
                >
                    <Tab label={t("Points")} value="points" />
                    <Tab label={t("Groups")} value="groups" />
                    <Tab label={t("Tariffs")} value="tariffs" />
                </Tabs>
            </Box>
            <Box pt={2} flexGrow={1} minHeight={0}>
                {activeTab === "points" && (
                    <MeteringPointEditor facility={facility} />
                )}
                {activeTab === "groups" && (
                    <MeteringGroupEditor facility={facility} />
                )}
                {activeTab === "tariffs" && (
                    <MeteringTariffEditor facility={facility} />
                )}
            </Box>
        </Stack>
    );
}
